var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Types as TwilioTypes } from './TwilioActions';
import { Types as ChannelTypes } from './ChannelActions';
import { Types as MessageTypes } from './MessageActions';
import { Types as MemberTypes } from './MemberActions';
import { Types as UserTypes } from './UserActions';
import { Types as OtherTypes } from './OtherActions';
export var Types = __assign(__assign(__assign(__assign(__assign(__assign({}, TwilioTypes), ChannelTypes), MessageTypes), MemberTypes), UserTypes), OtherTypes);
//# sourceMappingURL=Types.js.map